import { render, staticRenderFns } from "./declaredetail.vue?vue&type=template&id=b7555136&scoped=true"
import script from "./declaredetail.vue?vue&type=script&lang=js"
export * from "./declaredetail.vue?vue&type=script&lang=js"
import style0 from "./declaredetail.vue?vue&type=style&index=0&id=b7555136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7555136",
  null
  
)

export default component.exports